import axios from "axios";

let initialData = null;
let axiosPromise = null;

export default class ProductInitialDataService {
    async fetch() {
        if (initialData === null && axiosPromise === null) {
            const promise = axios.get('/v2/products/product-initial-data');
            promise.then(data => {
                initialData = data.data;
            });
            axiosPromise = promise;

            return promise;
        }

        return axiosPromise;
    }
}
